"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openNewTab = exports.navigateTo = void 0;

var navigateTo = function navigateTo(url) {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else {
    window.location.href = url;
  }
};

exports.navigateTo = navigateTo;

var openNewTab = function openNewTab(url) {
  window.open(url, '_blank');
};

exports.openNewTab = openNewTab;